import { render, staticRenderFns } from "./auth-callback.vue?vue&type=template&id=66497907&scoped=true&"
import script from "./auth-callback.vue?vue&type=script&lang=js&"
export * from "./auth-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66497907",
  null
  
)

export default component.exports